import {useState, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';

import { adminAPI } from '../../../api';

import {APIAccessAddModal} from './APIAccessAddModal'

import { GridColDef } from '@mui/x-data-grid';
import { convertToDateTime, StyledDataGrid, dataGridCellClassName, dataGridHeaderClassName } from '../../../utils'

interface Props {
}

const APIAccesses : React.FC<Props> = ({}) => {

  const [loaded, setLoaded] = useState<boolean>(false)
  const [hasNoData, setHasNoData] = useState<boolean>(false)
  const [projects, setProjects] = useState<any[]>([])
  const [showProjectAddModal, setShowProjectAddModal] = useState<boolean>(false)
  const navigate = useNavigate();

  useEffect(() => {
    loadProjects()
  }, [])

  async function loadProjects(){
    let {data: data} = await adminAPI.getProjects()
    setProjects(data['data'])
    setLoaded(true)
  }

  const columnsForMessages: GridColDef[] = [
    { field: 'for_load_testing', headerName: 'Type', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 120,
      renderCell: (params) => {
        return <span className={`badge badge-${params.value ? 'success' : 'info'}`}>
          {params.value ? 'Load Testing' : 'API Access'}
        </span>
      }
    },
    { field: 'name', headerName: 'Name', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 100, flex:1},
    { field: "created_by_email", headerName: 'Created/Approved By', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 200},
    { field: "created_dt", headerName: 'Created/Approved On', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 180,
      renderCell: (params) => {
        return convertToDateTime(params.value)
      }
    },
    { field: "api_access_request_full_name", headerName: 'Requested By', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 200},
    { field: 'number_of_api_requests', headerName: '# API Requests', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 150, 
      renderCell: (params) => {
        return params.value ? params.value.toLocaleString() : 0
      }
    },
    { field: 'latest_api_request_dt', headerName: 'Latest API Request On', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 180,
      renderCell: (params) => {
        return convertToDateTime(params.value)
      }
    },
    { field: 'deleted_dt', headerName: 'Access Status', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 150,
      renderCell: (params) => {
        return <span className={`badge badge-light-${params.value ? 'danger' : 'primary'}`}>
          {params.value ? 'deleted' : 'active'}
        </span>
      }
    },
    { field: 'api_access_status', headerName: 'API Key Status', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 150,
      renderCell: (params) => {
        return <span className={`badge badge-light-${params.row.api_access_status == 'active' ? 'primary' : 'danger'}`}>
          {params.row.api_access_status ? params.row.api_access_status : 'deleted'}
        </span>
      }
    },
    { field: 'api_access_rate_limit_per_minute', headerName: 'Rate Limit', headerClassName: dataGridHeaderClassName, cellClassName: dataGridCellClassName, minWidth: 120},
  ]

  const handleRowClick = (params: any) => {
    navigate(params.row.id)
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="d-flex justify-content-between">
          <button className="btn btn-sm btn-light-dark" onClick={()=>setShowProjectAddModal(true)}>
            Add
          </button>
        </div>
        <div className="row mt-5">
          {!hasNoData && projects && (
              <StyledDataGrid
                getRowId={(row) => row.id}
                rows={projects}
                onRowClick={handleRowClick}
                columns={columnsForMessages}
                disableColumnMenu={false}
                getRowHeight={() => 'auto'}
                disableRowSelectionOnClick
                sx={{
                  border: 0,
                  '& .MuiDataGrid-row:hover': {
                    cursor: 'pointer',
                  },
                }}
                initialState={{
                  pagination: {
                    paginationModel: { page: 0, pageSize: 50 },
                  }
                }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                  },
                }}
                pageSizeOptions={[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100]}
              />
            )}
        </div>
      </div>
      <APIAccessAddModal show={showProjectAddModal} handleClose={() => setShowProjectAddModal(false)} handleAdded={loadProjects}/>
    </div>
  )
}

export default APIAccesses